import React from "react";

/** Shown after user chooses to queue a transfer that had insufficient funds. */
export const QueuedAuthorizationSuccessStep = ({ onClose }) => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title yellow">{Drupal.t("Success!")}</h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
        <p>
          {Drupal.t(
            "The bank transfer has been queued and will be paid once sufficient funds have been loaded into your account.",
          )}
        </p>
      </div>
      {onClose && (
        <div className="authorise-bank-transfer-actions text-center mt-3">
          <button type="button" className="primary_btn" onClick={onClose}>
            {Drupal.t("Done")}
          </button>
        </div>
      )}
    </div>
  </>
);
